import React from "react";

const Hero = () => (
	<section className="bg-red-500 text-white py-20 text-center">
		<h2 className="text-4xl font-extrabold mb-4">
			Innovating Development Solutions
		</h2>
		<p className="text-lg mb-6">
			We build sustainable IT and infrastructure solutions.
		</p>
		<a
			href="#contact"
			className="bg-white text-red-500 px-6 py-2 rounded shadow hover:bg-gray-100"
		>
			Get in Touch
		</a>
	</section>
);

export default Hero;
